import * as React from "react";

import { Badge } from "@repo/ui/components/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@repo/ui/components/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@repo/ui/components/table";
import { createFileRoute } from "@tanstack/react-router";

import { buildIpadFilename } from "@/lib/filename-utils";

export const Route = createFileRoute("/_authed/filenames/teams")({
  head: () => ({ meta: [{ title: "Teams" }] }),
  component: RouteComponent,
});

function RouteComponent() {
  const teams = React.useMemo(
    () => [
      { name: "Team Falcons", code: "FLC", region: "MENA", slot: "09:00", ready: true },
      { name: "Fnatic", code: "FNC", region: "EMEA", slot: "10:30", ready: true },
      { name: "Sentinels", code: "SEN", region: "NA", slot: "11:00", ready: true },
      { name: "T1", code: "T1", region: "KR", slot: "12:30", ready: false },
      { name: "Gen.G", code: "GENG", region: "KR", slot: "14:00", ready: true },
      { name: "NAVI", code: "NAVI", region: "EMEA", slot: "15:00", ready: false },
    ],
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Team naming preview</CardTitle>
        <CardDescription>Keep team exports short, readable, and safe on iPad.</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Team</TableHead>
              <TableHead>Code</TableHead>
              <TableHead>Region</TableHead>
              <TableHead>Media slot</TableHead>
              <TableHead>iPad filename</TableHead>
              <TableHead>Ready</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {teams.map((team) => (
              <TableRow key={team.name}>
                <TableCell className="font-medium">{team.name}</TableCell>
                <TableCell>{team.code}</TableCell>
                <TableCell>{team.region}</TableCell>
                <TableCell>{team.slot}</TableCell>
                <TableCell className="font-mono text-xs">
                  {buildIpadFilename([team.code, team.region, team.name])}
                </TableCell>
                <TableCell>
                  <Badge variant={team.ready ? "secondary" : "outline"}>
                    {team.ready ? "ready" : "pending"}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
